import { useEffect } from 'react';
import { toast } from 'react-toastify';
import { useAuthStore } from 'store/authStore';
import { createEcho, destroyEcho } from 'lib/echo';

/**
 * Abre una conexión WebSocket con Reverb y escucha el evento `force-logout`
 * en el canal privado del usuario autenticado.
 *
 * Cuando el admin fuerza el cierre de sesión desde el panel de sesiones,
 * Reverb entrega el evento en tiempo real y este hook:
 *  1. Muestra un toast de aviso.
 *  2. Llama clearAuth() para limpiar el estado y redirigir al login.
 *
 * Se monta en MainLayout (solo cuando el usuario está autenticado).
 * Se desmonta al hacer logout normal, desconectando Echo automáticamente.
 */
export function useForceLogout(): void {
  const token     = useAuthStore((s) => s.token);
  const keyUser   = useAuthStore((s) => s.user?.keyUser);
  const clearAuth = useAuthStore((s) => s.clearAuth);

  useEffect(() => {
    if (!token || !keyUser) return;

    const echoInstance = createEcho(token);

    echoInstance
      .private(`user.${keyUser}`)
      .listen('.force-logout', () => {
        toast.warning('Tu sesión fue cerrada por el administrador.', {
          toastId:      'force-logout',
          autoClose:    3000,
          closeOnClick: false,
        });
        setTimeout(() => {
          clearAuth(); // destroyEcho() se llama desde clearAuth en authStore
        }, 3000);
      });

    return () => {
      destroyEcho();
    };
  }, [token, keyUser]);
}
